import { Controller } from '@hotwired/stimulus'

// Syncs color picker with adjacent text input
// Usage: data-controller="admin--color-sync" on the text input
export default class extends Controller {
  connect() {
    // Find the color input sibling
    const container = this.element.closest('.flex')
    if (container) {
      this.colorInput = container.querySelector('input[type="color"]')
      if (this.colorInput) {
        this.colorInput.addEventListener('input', this.syncFromPicker.bind(this))
        this.element.addEventListener('input', this.syncToPicker.bind(this))
      }
    }
  }

  disconnect() {
    if (this.colorInput) {
      this.colorInput.removeEventListener('input', this.syncFromPicker.bind(this))
    }
  }

  syncFromPicker() {
    this.element.value = this.colorInput.value
  }

  syncToPicker() {
    // Only sync if valid hex color
    const value = this.element.value
    if (/^#[0-9A-Fa-f]{6}$/.test(value)) {
      this.colorInput.value = value
    }
  }
}
